import myData from '../_json/english.json';
export default function Messages (){
    const allMessages = myData
    return allMessages
}